import axios from 'axios'
import router from '../../router'

const state = {
// sampleData: ''
    ordMstInfo: '',
    ordDtlInfo: '',
    ordItemInfo: '',
    ordSaveInfo: ''

}
  
const getters = {
    getOrdMstInfo (state) {
        return state.ordMstInfo
    },
    getOrdDtlInfo (state) {
        return state.ordDtlInfo
    },
    getOrdItemInfo (state) {
        return state.ordItemInfo
    },
    getOrdSaveInfo (state) {
        return state.ordSaveInfo
    },
}

const mutations = {
    setOrdMstInfo (state, payload) {
        state.ordMstInfo = payload
    },
    setOrdDtlInfo (state, payload) {
        state.ordDtlInfo = payload
    },
    setOrdItemInfo (state, payload) {
        state.ordItemInfo = payload
    },
    setOrdSaveInfo (state, payload) {
        state.ordSaveInfo = payload
    }
}
  
const actions = {
    apiOrdMstInfo  (context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/api/ordMst', payload)
                .then((response) => {
                context.commit('setOrdMstInfo', response.data)
                resolve()
                })
                .catch((error) => {
                if (error.response.status === 410) {
                    alert('세션이 만료되어 로그인 페이지로 이동합니다.')
                    sessionStorage.clear()
                    router.replace('/')
                }else{
                    // console.log('error  = ' + error.message)
                    // console.log(JSON.stringify(error))
                    reject(error)
                    // console.log('error.response.status = ' + error.response.status)
                }
                // alert('ErrorCode = ' + error.response.status + ' / ' + error.message)
            })
        })
    },
    apiOrdDtlInfo  (context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/api/ordDtl', payload)
                .then((response) => {
                context.commit('setOrdDtlInfo', response.data)
                resolve()
                })
                .catch((error) => {
                if (error.response.status === 410) {
                    alert('세션이 만료되어 로그인 페이지로 이동합니다.')
                    sessionStorage.clear()
                    router.replace('/')
                }else{
                    // console.log('error  = ' + error.message)
                    // console.log(JSON.stringify(error))
                    reject(error)
                    // console.log('error.response.status = ' + error.response.status)
                }
                // alert('ErrorCode = ' + error.response.status + ' / ' + error.message)
                })
        })
    },
    apiOrdItemInfo  (context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/api/getOrderItem', payload)
                .then((response) => {
                    context.commit('setOrdItemInfo', response.data)
                    resolve()
                })
                .catch((error) => {
                if (error.response.status === 410) {
                    alert('세션이 만료되어 로그인 페이지로 이동합니다.')
                    sessionStorage.clear()
                    router.replace('/')
                }else{
                    // console.log('error  = ' + error.message)
                    // console.log(JSON.stringify(error))
                    reject(error)
                    // console.log('error.response.status = ' + error.response.status)
                }
                // alert('ErrorCode = ' + error.response.status + ' / ' + error.message)
                })
        })
    },
    apiOrdSaveInfo  (context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/api/saveOrder', payload)
                .then((response) => {
                    context.commit('setOrdSaveInfo', response.data)
                    resolve()
                })
                .catch((error) => {
                if (error.response.status === 410) {
                    alert('세션이 만료되어 로그인 페이지로 이동합니다.')
                    sessionStorage.clear()
                    router.replace('/')
                }else{
                    // console.log('error  = ' + error.message)
                    // console.log(JSON.stringify(error))
                    reject(error)
                    // console.log('error.response.status = ' + error.response.status)
                }
                // alert('ErrorCode = ' + error.response.status + ' / ' + error.message)
                })
        })
    }
/*apiPreMstInfo (context, payload) {
    if (sessionStorage.getItem('userInfo') === null) {
    alert('세션이 만료되어 로그인 페이지로 이동합니다.')
    sessionStorage.clear()
    router.replace('/')
    }else{
    return new Promise((resolve, reject) => {
        axios.post('/api/orderMst', payload)
        .then((response) => {
            context.commit('setPreMstInfo', response.data)
            resolve()
        })
        .catch((error) => {
            if (error.response.status === 410) {
            alert('세션이 만료되어 로그인 페이지로 이동합니다.')
            sessionStorage.clear()
            router.replace('/')
            }else{
            // console.log('error  = ' + error.message)
            // console.log(JSON.stringify(error))
            reject(error)
            // console.log('error.response.status = ' + error.response.status)
            }
            // alert('ErrorCode = ' + error.response.status + ' / ' + error.message)
        })
    })
    }*/
}
  
  
export default {
    state,
    getters,
    mutations,
    actions
}
  